/*
  Collection landing: "Show the other 4" under the whole collection (sections/btf-landing-more.liquid).
  Horizon's main-collection grid shows the first page; a phone shows only the first few of those
  (assets/btf-landing.css). The button reveals them and appends the collection's further pages,
  fetched as the grid section alone, then goes away. A sort re-renders the grid: the count resets.
*/
class BtfLandingMore extends HTMLElement {
  connectedCallback() {
    this.total = Number(this.dataset.total) || 0;
    this.mobileCount = Number(this.dataset.mobile) || 12;
    this.mq = window.matchMedia('(max-width: 749px)');
    this.btn = this.querySelector('[data-more-btn]');
    this.btn.addEventListener('click', () => this.more());
    this.mq.addEventListener('change', () => this.update());
    this.list = document.querySelector('results-list');
    if (this.list) {
      new MutationObserver(() => this.update()).observe(this.list, { childList: true, subtree: true });
    }
    this.update();
  }

  get grid() {
    return this.list?.querySelector('.product-grid');
  }

  get items() {
    return this.grid ? [...this.grid.querySelectorAll(':scope > .product-grid__item')] : [];
  }

  shown() {
    const n = this.items.length;
    return this.mq.matches && !this.grid?.classList.contains('btf-open') ? Math.min(n, this.mobileCount) : n;
  }

  update() {
    if (this.busy) return;
    const shown = this.shown();
    const rest = Math.max(0, this.total - shown);
    const out = this.querySelector('[data-shown]');
    if (out) out.textContent = String(shown);
    const label = (this.mq.matches ? this.dataset.more : this.dataset.other) || '';
    this.btn.textContent = label.replace('[rest]', String(rest));
    this.btn.hidden = rest === 0;
    this.toggleAttribute('data-done', rest === 0);
  }

  async more() {
    const grid = this.grid;
    if (!grid || this.busy) return;
    this.busy = true;
    this.btn.setAttribute('aria-busy', 'true');
    const first = this.shown();
    grid.classList.add('btf-open');
    try {
      const section = this.list.closest('.shopify-section')?.id.replace('shopify-section-', '');
      let page = Number(this.items.at(-1)?.dataset.page) || 1;
      while (section && this.items.length < this.total) {
        page += 1;
        const url = new URL(window.location.href);
        url.searchParams.set('page', String(page));
        url.searchParams.set('section_id', section);
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) break;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const next = doc.querySelectorAll('.product-grid > .product-grid__item');
        if (!next.length) break;
        grid.append(...next);
      }
    } finally {
      this.busy = false;
      this.btn.removeAttribute('aria-busy');
      this.update();
      // Keyboard and screen-reader users land on the first board they had not seen
      this.items[first]?.querySelector('a')?.focus({ preventScroll: true });
    }
  }
}

if (!customElements.get('btf-landing-more')) customElements.define('btf-landing-more', BtfLandingMore);
